import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, CheckboxUI, AutoCompleteSelectUI, ButtonUI } from '../../Interface';

const AlertFormFields = ({ viewField, autocompleteOptions, autocompleteData, openAlertFormDialog }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  const handleFieldChange = async (field, newVal) => {
    const selected = newVal?.value ?? null;
    await setFieldValue(field, selected);
    await validateField(field);
  };

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-2 col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Riasztás neve" />}
          helperText={<FormErrorUI message={errors.name} />}
          variant="standard"
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
          disabled={viewField}
        />
      </div>

      <div className="md:col-span-2 col-span-4">
        <Field
          type="autocomplete"
          name="view"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Riasztás forrása" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.view} />}
          onChange={async (_e, newVal) => handleFieldChange('view', newVal)}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.view) }}
          selectedValue={values.view}
          selectedLabelValue={autocompleteOptions?.views.find((item) => item.value === values.view)?.label || ''}
          dataset={autocompleteOptions?.views}
        />
      </div>

      <div className="md:col-span-2 col-span-4">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>

      <div className="md:col-span-2 col-span-4">
        <ButtonUI
          text="Részletek"
          size="sm"
          className="bg-labelColor py-3"
          onClick={() => openAlertFormDialog()}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default AlertFormFields;
